


export function onElementResize(elm, callback) {
  new ResizeObserver(callback).observe(elm)
}


export function arrayCount(arr) {
  const counts = {};
  arr.forEach((x) => {
    counts[x] = (counts[x] || 0) + 1;
  });
  return counts;
}

export function formatTime(t){
  let time = t;
  var minutes = Math.floor(time / 60);
  var seconds = Math.floor(time - minutes * 60);
  //var hours = Math.floor(time / 3600);
  //time = time - hours * 3600;

  function str_pad_left(string,pad,length) {
    return (new Array(length+1).join(pad)+string).slice(-length);
  }

  var finalTime = str_pad_left(minutes,'0',2)+':'+str_pad_left(seconds,'0',2);
  return finalTime;
}